import React from 'react'

export default function CareerAdvice() {
  return (
    <div>
      Career Advice
    </div>
  )
}
